export default {
  None: 0,
  Success: 1,
  InHandler: 2,
  Error: -1
};
